// Shared payment eligibility for directory, matching, and intake.
import { withoutFill } from '../data/taxonomy.js';

export const FLEXIBLE_INSURANCE = ['Out of network / self-pay', "I'm not sure yet"];
// Contact-form checkbox VALUES. Netlify and downstream automations match on
// these strings: never rename one. Add or remove only with Cameron's OK
// (Excellus BCBS + Highmark BCBS of NY added 2026-10-14).
export const INTAKE_INSURANCE_OPTIONS = [
  'Aetna', 'Anthem (BCBS)', 'Excellus BCBS', 'Highmark BCBS of NY', 'Carelon', 'Cigna', 'EmblemHealth',
  'Empire Plan (NYSHIP)', 'MagnaCare', 'Meritain', 'NYCE PPO', 'Optum',
  'Oscar', 'Oxford', 'UMR', 'United HealthCare', 'Out of Network / Self Pay', 'Not Sure Yet',
];
// Form value -> plan name in the clinicians' *InsuranceAccepted arrays.
// Values not listed here are already plan names.
export const INTAKE_PLAN_ALIASES = {
  'Anthem (BCBS)': 'Anthem / Empire BlueCross',
  'Empire Plan (NYSHIP)': 'NYSHIP / The Empire Plan',
  Optum: 'United HealthCare / Optum',
  'United HealthCare': 'United HealthCare / Optum',
};
// Plans with no checkbox of their own: they route like the form value given
// (out-of-state Blue plans are covered by everyone who takes Anthem).
const INTAKE_VALUE_FOR_PLAN = { 'Out-of-state BCBS (BlueCard)': 'Anthem (BCBS)' };
export function isFlexibleInsurance(value) {
  return !value || [...FLEXIBLE_INSURANCE, 'Out of Network / Self Pay', 'Not Sure Yet'].includes(value);
}
export function acceptsInsurance(clinician, insurance) {
  if (isFlexibleInsurance(insurance)) return true;
  if (!clinician) return false;
  const plans = withoutFill(clinician.insurance || clinician.insuranceAccepted);
  const plan = INTAKE_PLAN_ALIASES[insurance] || insurance;
  // Out-of-network access (client pays their in-network copay) routes like in-network.
  return !plans.length || plans.includes(plan) || (clinician.outOfNetworkAccess || []).includes(plan);
}
export function intakeInsurance(value) {
  if (!value) return '';
  if (value === FLEXIBLE_INSURANCE[0]) return 'Out of Network / Self Pay';
  if (value === FLEXIBLE_INSURANCE[1]) return 'Not Sure Yet';
  if (INTAKE_INSURANCE_OPTIONS.includes(value)) return value;
  if (INTAKE_VALUE_FOR_PLAN[value]) return INTAKE_VALUE_FOR_PLAN[value];
  return Object.keys(INTAKE_PLAN_ALIASES).find((key) => INTAKE_PLAN_ALIASES[key] === value) || '';
}
